import { render } from "./PrevFin.vue?vue&type=template&id=4c60f1de"
import script from "./PrevFin.vue?vue&type=script&lang=js"
export * from "./PrevFin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__